import { BehaviorSubject } from "rxjs";
function createStore(initialValue) {
    var store = new BehaviorSubject(initialValue);
    return store;
}
export default createStore;

//# sourceMappingURL=createStore.js.map